export const obTglDetail = (ref: React.MouseEvent<HTMLElement>, refContQuerySel: string, currentIndex: number, context: number) => {
	const refEle = ref.currentTarget as any,
		refCont = document.querySelector(refContQuerySel); //parent container
	refCont?.querySelectorAll(".expand").forEach((e: Element, i: number) => {
		i !== currentIndex && e.classList.remove("expand");
	});
	refCont?.querySelectorAll(".hide").forEach((e: Element, i: number) => i !== currentIndex && e.classList.remove("hide"));
	if (refEle) {
		//context(0)refer to the row
		if (context === 0) {
			if (refEle.nextElementSibling.className.indexOf("expand") < 0) {
				refEle.nextElementSibling.className += " expand";
				refEle.className += " hide";
			} else {
				refEle.nextElementSibling.classList.remove("expand");
				refEle.classList.remove("hide");
			}
		}
		//context(1)refer to the expanded row
		if (context === 1) {
			refEle.classList.remove("expand");
			refEle.previousElementSibling.classList.remove("hide");
		}
	}
};
